import "../assets/styles/Toggle.css";

import Switch from '@mui/joy/Switch';
import { Typography } from '@mui/joy';

const LanguageToggle = ({ lang, toggleLanguage, standalone = true }) => {
  const switchComponent = (
      <Switch
        color={lang === 'ar' ? 'success' : 'neutral'}
        slotProps={{ input: { 'aria-label': 'language toggle' } }}
        startDecorator={
          <Typography
            level="body-xs"
            fontWeight="light"
            sx={[
              lang === 'en' 
                ? { color: 'neutral.600' } 
                : { color: 'text.tertiary' }
            ]}
          >
            EN
          </Typography>
        }
        endDecorator={
          <Typography
            level="body-xs"
            fontWeight="light"
            sx={[
              lang === 'ar' 
                ? { color: 'success.500' } 
                : { color: 'text.tertiary' }
            ]}
          >
            AR
          </Typography>
        }
        checked={lang === 'ar'}
        onChange={(event) => toggleLanguage()}
      />
  );

  if (standalone) {
    return <div className="language-toggle">{switchComponent}</div>;
  }

  return switchComponent;
};

export default LanguageToggle;